import config from "@/config"
import http from "@/utils/request"

export default {
	token: {
		url: `${config.API_URL}/manage/member/login`,
		name: "登录获取TOKEN",
		post: async function(data={}){
			return await http.post(this.url, data);
		}
	},
	logout: {
		url: `${config.API_URL}/manage/member/logout`,
		name: "退出登录",
		post: async function(data={}, config={}){
			return await http.post(this.url, data, config);
		}
	}
}
